const header = document.querySelector(".shopify-section-header");
const megaMenuLinks = document.querySelectorAll(".list-menu--megamenu");
const openSearchBtn = document.querySelector(".header__search");
const searchDetails = document.querySelector(".header__details");
const headerIsAlwaysSticky =
			header
				.querySelector(".header-wrapper")
				.getAttribute("data-sticky-type") === "always";
const body = document.querySelector("body");
const headerIsSticky =
			header
				.querySelector(".header-wrapper")
				.getAttribute("data-sticky-type") === "on-scroll-up";
//let timer;
let run;
header.classList.add("animate");

megaMenuLinks.forEach((link) => {
    link.addEventListener("mouseenter", () => {
        let scrollTop = window.scrollY;
        link.classList.add("list-menu--megamenu-visible");
        header.classList.add(
            "fixed",
            "shopify-section-header-sticky"
        );
        if (
            true//scrollTop < header.offsetHeight / 2
        ) {
            header.classList.add(
                "fixed",
                "shopify-section-header-sticky"
            );
        }

        link.addEventListener("mousemove", () => {
            link.classList.add("list-menu--megamenu-visible");
            //run = false;
        });

        link.addEventListener("mouseleave", () => {
            run = true;
            setTimeout(() => {
                if (run) {
                link.classList.remove("list-menu--megamenu-visible");
                header.classList.remove(
                    "fixed",
                    "shopify-section-header-sticky"
                );
            }
            }, 300);
            //timer = window.setTimeout(function(){},300); 
            
            
            
        });
        link.addEventListener("mouseenter", () => {
            link.classList.add("list-menu--megamenu-visible");
            //window.clearTimeout(timer);
            // if (run) {
            //     console.log('is running');
            //     run = false;
            // }
            header.classList.add(
                "fixed",
                "shopify-section-header-sticky"
            );
            run = false;
        });
    });
});

if (openSearchBtn) {
    openSearchBtn.addEventListener("click", () => {
        let scrollTop = window.scrollY;
        if (searchDetails.open && headerIsAlwaysSticky) {
            body.classList.add("overflow-hidden");
            header.classList.add(
                "shopify-section-header-sticky",
                "fixed",
            );
        } else if (searchDetails.open && !headerIsAlwaysSticky) {
            body.classList.add("overflow-hidden");
            header.classList.add("shopify-section-header-sticky", "animate", "fixed");
        } else if (
            !searchDetails.open &&
            scrollTop < header.offsetHeight / 2 &&
            headerIsSticky
        ) {
            body.classList.remove("overflow-hidden");
            header.classList.remove(
                "fixed",
                "shopify-section-header-sticky",
            );
        } else if (
            !searchDetails.open &&
            scrollTop < header.offsetHeight / 2 &&
            headerIsAlwaysSticky
        ) {
            body.classList.remove("overflow-hidden");
            header.classList.remove("animate", "animated");
        } else if (
            !searchDetails.open &&
            scrollTop > header.offsetHeight / 2 &&
            (headerIsSticky || headerIsAlwaysSticky)
        ) {
            body.classList.remove("overflow-hidden");
            header.classList.add(
                "shopify-section-header-sticky",
                "fixed",
            );
        } else if (
            !searchDetails.open &&
            !headerIsAlwaysSticky &&
            !headerIsSticky
        ) {
            body.classList.remove("overflow-hidden");
            header.classList.remove(
                "shopify-section-header-sticky",
                "fixed",
            );
        } else {
            body.classList.remove("overflow-hidden");
            header.classList.remove(
                "shopify-section-header-sticky",
                "fixed",
            );
        }
    });
}